import { XIcon } from "lucide-react";
import { ProductList } from "./ProductList";
import { MenuCategory } from "@/hooks/useMenu";

function CategoryDrawer({
  category,
  handleClose,
}: {
  category?: MenuCategory;
  handleClose: () => void;
}) {
  return (
    <div className="z-[1]">
      {category && (
        <div className="rounded-t-xl md:rounded-tr-none md:rounded-bl-xl bg-background max-md:max-h-[90dvh] md:min-w-[60vw] md:h-[100vh] md:w-full md:max-w-[80vw]">
          <header className="p-4 flex flex-row items-center justify-between border-b">
            <div className="flex flex-col">
              <h1 className="text-xl font-medium tracking-tight">
                {category.name}
              </h1>
              <span className="text-muted-foreground">
                {category.products.length} items
              </span>
            </div>
            <button
              type="button"
              className="bg-muted rounded-full h-11 w-11 aspect-square flex items-center justify-center grow-0 shrink-0"
              onClick={handleClose}
              aria-label="Close category"
            >
              <XIcon size={14} />
            </button>
          </header>
          <div className="max-lg:max-h-[75dvh] md:max-h-[90dvh] overflow-y-auto pb-[100px]">
            <ProductList products={category.products} />
          </div>
        </div>
      )}
    </div>
  );
}

export { CategoryDrawer };
